/**
 * Parses a numeric media ID from a crave.ca content URL.
 *
 * Crave content URLs follow the pattern:
 *   https://www.crave.ca/<locale>/<type>/<slug>-<id>
 * e.g. https://www.crave.ca/en/series/euphoria-45159  → "45159"
 *      https://www.crave.ca/fr/films/dune-45159        → "45159"
 *
 * Returns the numeric ID string, or null if the URL does not match.
 */
export const parseMediaIdFromContentUrl = (url: string): string | null => {
  let pathname: string;
  try {
    pathname = new URL(url).pathname;
  } catch {
    return null;
  }

  const lastSegment = pathname.split('/').filter(Boolean).pop();
  if (!lastSegment) return null;

  const match = lastSegment.match(/-(\d+)$/);
  return match ? match[1] : null;
};
